export const containsES6SyntaxOrJSX = (code) => {
    const es6Patterns = [
        /\bimport\b/,
        /\bexport\b/
    ];
    const jsxPattern = /<([A-Za-z][A-Za-z0-9]*)(\s+[A-Za-z0-9\-]+(\s*=\s*{[^}]*}|="[^"]*"|='[^']*'|=[^>\s]+)?)*\s*\/?>/;
    return es6Patterns.some(pattern => pattern.test(code)) || jsxPattern.test(code);
};

export function parseSecrets(code) {
    const secretsPattern = /{{\s*secrets\.([a-zA-Z0-9_]+)\s*}}/g;
    let match;
    const secrets = [];

    while ((match = secretsPattern.exec(code)) !== null) {
        secrets.push(match[1]);
    }

    return secrets;
}

export function getMimeTypeByFilepath(filepath) {
    let type = "text/javascript"; // Default type

    if (filepath.endsWith('.json')) {
        type = "application/json";
    }

    return type;
}

export const FRONTEND_MODULES = {
    contentRender: {}
}

export const EVENT_MODULES = {
    onRequest: {},
    onResponse: {}
}

export function extractModuleNames(filePaths) {
    const uniqueModuleNames = new Set();
    filePaths.forEach(filePath => {
        const match = filePath.match(/\/([^\/]+)\.\w+$/);
        if (match && FRONTEND_MODULES.hasOwnProperty(match[1])) {
            uniqueModuleNames.add(match[1]);
        } else if (match && EVENT_MODULES.hasOwnProperty(match[1])) {
            uniqueModuleNames.add(match[1]);
        }
    });
    return Array.from(uniqueModuleNames);
}
